import { Box } from "@mui/material";
import { type PointerEvent as ReactPointerEvent } from "react";

interface ResizeHandleProps {
	onPointerDown: (e: ReactPointerEvent) => void;
	/** "col-resize" for an in-flow divider, "ew-resize" for a drawer edge. */
	cursor?: "col-resize" | "ew-resize";
	/** Absolutely pin to the left edge of the positioned parent (drawer use). */
	absolute?: boolean;
	dataComponent?: string;
}

/**
 * 8px draggable handle that highlights in the primary colour on hover. Shared by
 * the resizable drawer edge, the person two-column divider and the grading split.
 */
export const ResizeHandle = ({
	onPointerDown,
	cursor = "col-resize",
	absolute = false,
	dataComponent = "resize-handle",
}: ResizeHandleProps) => (
	<Box
		onPointerDown={onPointerDown}
		role="separator"
		aria-orientation="vertical"
		data-component={dataComponent}
		sx={{
			flexShrink: 0,
			width: "8px",
			cursor,
			// Prevent touch-scroll from hijacking a drag on touch/pen devices.
			touchAction: "none",
			backgroundColor: "transparent",
			transition: "background-color 0.15s",
			"&:hover": { bgcolor: "primary.main" },
			...(absolute
				? {
						position: "absolute",
						left: 0,
						top: 0,
						bottom: 0,
						zIndex: (theme) => theme.zIndex.drawer + 1,
					}
				: {}),
		}}
	/>
);
